import { createIconComponent } from '../../factory/create-icon-component';
export const CirclePlusIcon = createIconComponent(
  'CirclePlusIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 12H12M12 12H16M12 12V8M12 12V16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C13.4222 2 14.7751 2.2969 16 2.83209C17.7525 3.68158 18.6284 4.37477 20 5.99902C21.2558 7.67051 22 9.74835 22 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
